import { call, put } from 'redux-saga/effects';
import * as SagaTypes from './saga-types';

import {
  claimedPaitentByUserFailure,
  claimedPaitentByUserRequest,
  claimedPaitentByUserSuccess,
} from '../actions';
import { urls } from '../constants/constants';
import * as Api from '../api';

export function* convertUnclaimedToClaimedUser(action) {
  yield put(claimedPaitentByUserRequest());
  const userId = action.payload.param.userId;
  const patientId = action.payload.param.patientId;
  const userName = action.payload.param.userName;
  try {
    const result = yield call(
      Api.put,
      `${urls.aspariaBackend}api/v1/patient/claimPatient`,
      { userId, patientId, userName }
    );
    if (result) {
      action.callback();
      yield put(claimedPaitentByUserSuccess(result.data.data));
    } else {
      yield put(claimedPaitentByUserFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(claimedPaitentByUserFailure(e));
  }
}

export const claimedPatientByUser = (param, cb) => ({
  type: SagaTypes.CONVERT_UNCLAIMED_PATIENT_TO_CLAIMED_PATIENT,
  payload: { param },
  callback: cb,
});
